import { render, staticRenderFns } from "./RequestPasswordModal.vue?vue&type=template&id=6a5ee1d4&"
import script from "./RequestPasswordModal.vue?vue&type=script&lang=ts&"
export * from "./RequestPasswordModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports